import API from '../baseService';

export const subscriberInformation = companyId =>
  API.get(`/subscribers/${companyId}`).then(response => response.data);
